export const tierName = {
  0: "Tier 1",
  1: "Tier 2",
  2: "Tier 3",
  3: "No Tier",
};
